<template>
  <NuxtLoadingIndicator color="#29418f" />
  <NuxtLayout>
    <!-- <NuxtPage @entry-loaded="setEntry" /> -->
    <!-- <UiLoadingIndicator /> -->
    <NuxtPage />
    <NuxtPwaManifest />
  </NuxtLayout>
</template>

<script setup lang="ts">
import Fuse from 'fuse.js'

import { usePrefetch } from './composables/usePrefetch'
import {
  FuseInjectionKey,
  useInjectableFuse,
  type OfflineSearchResult,
} from './composables/useInjectableFuse'

const injectedFuse = ref<Fuse<OfflineSearchResult>>()
provide(FuseInjectionKey, injectedFuse)

onMounted(async () => {
  const results = await usePrefetch()
  injectedFuse.value = useInjectableFuse(results ?? {})
})

const { locale } = useI18n()
onMounted(async () => {
  const addToHomeScreen = await import('~/assets/add-to-homescreen.min.js');
  (window as any).AddToHomeScreenInstance = (window as any).AddToHomeScreen({
    appName: 'Desitin Vademecum',
    appNameDisplay: 'standalone',
    appIconUrl: '/apple-touch-icon.png',
    assetUrl: '/add-to-homescreen/',

    maxModalDisplayCount: 1,
    displayOptions: { showMobile: true, showDesktop: true },
    allowClose: true,
    showArrow: true,
  });

  (window as any).AddToHomeScreenInstance.show(locale.value);
})

</script>
